import "../scss/style.scss";
import "scroll-hint/css/scroll-hint.css";
import ScrollHint from "scroll-hint";
import "./anime.js"
import "./splide_setting.js"
import "./splide-extension-auto-scroll.js"
import "./index.js"
import "./dropdown.js"
import "./header-subnav-position.js"
import "./form-file.js"
import "./form-submit-loading.js"

// ScrollHint初期化
if (typeof window !== 'undefined') {
  window.ScrollHint = ScrollHint;
}
